import { Component, ViewEncapsulation, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { IEmergencia } from 'modelos/src';
import { CardHeaderComponent } from '../../../../../../componentes/card-header/card-header.component';
import { ContentCardComponent } from '../../../../../../componentes/content-card/content-card.component';
import { InfoBannerComponent } from '../../../../../../componentes/info-banner/info-banner.component';
import { ButtonComponent } from '../../../../../../auxiliares/button/button.component';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';

export interface ICancelarEmergenciaDialogData {
  emergencia: IEmergencia;
  guardar: (datos: {
    motivoCancelacion: string;
    observaciones?: string;
  }) => Promise<unknown>;
}

@Component({
  selector: 'app-cancelar-emergencia-dialog',
  templateUrl: './cancelar-emergencia-dialog.component.html',
  styleUrl: '../acciones-emergencia-dialog.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    CardHeaderComponent,
    ContentCardComponent,
    InfoBannerComponent,
    ButtonComponent,
  ],
})
export class CancelarEmergenciaDialogComponent {
  private dialogRef = inject(MatDialogRef<CancelarEmergenciaDialogComponent>);
  private helper = inject(HelperService);
  public data = inject<ICancelarEmergenciaDialogData>(MAT_DIALOG_DATA);

  public titulo = `Cancelar la emergencia ${this.data.emergencia.codigo ?? ''}`;
  public guardando = false;
  public form = new FormGroup({
    motivoCancelacion: new FormControl<string>('', [
      Validators.required,
      Validators.pattern(/\S/),
    ]),
    observaciones: new FormControl<string>(''),
  });

  public async guardar(): Promise<void> {
    if (this.form.invalid || this.guardando) return;
    this.guardando = true;
    try {
      await this.data.guardar({
        motivoCancelacion: this.form.value.motivoCancelacion!.trim(),
        observaciones: this.form.value.observaciones?.trim() || undefined,
      });
      this.dialogRef.close(true);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.guardando = false;
  }

  public cerrar(): void {
    this.dialogRef.close(false);
  }
}
